import { render, staticRenderFns } from "./NewSize.vue?vue&type=template&id=d23562e2&"
import script from "./NewSize.vue?vue&type=script&lang=ts&"
export * from "./NewSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports